import(/* webpackMode: "eager" */ "/vercel/path0/frontend/src/app/(marketing)/depth-test/page.tsx");
